import { Route } from "@angular/router";
import { ContactFormComponent } from "./contact-form.component";

export const ContactFormRouting : Route ={
  path: "contact-form",
  component: ContactFormComponent,
  data: {
    breadcrumb: "Formulaire de contact"
  }
};
